<template>
  <div
    :style="{
      fontWeight: fontWeight,
      fontSize: fontSize,
      textAlign: textAlign,
      margin: margin,
      color: color,
      fontStyle: fontStyle,
      fontFamily: fontFamily,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LayoutText',
  props: {
    fontWeight: {
      type: Number,
      default: 400,
    },
    fontSize: {
      type: String,
      default: '14px',
    },
    textAlign: {
      type: String,
      default: 'center',
    },
    margin: {
      type: String,
      default: '0',
    },
    color: {
      type: String,
      default: '#0C0058',
    },
    fontFamily: {
      type: String,
      default: 'Arial, Helvetica, sans-serif',
    },
    fontStyle: {
      type: String,
      default: 'normal',
    },
  },
}
</script>
